var exports = {
  "z": "suggestionTitle__tdjh1P",
};

module.exports = exports;
